{ 
    const ACCORDION_SELECTOR = 'bux-accordion'

    const KEYS = {
        up: 'ArrowUp',
        down: 'ArrowDown',
        home: 'Home',
        end: 'End',
    };

    class BuxAccordion {
        private readonly triggers: HTMLElement[];
        private readonly allowMultiple: boolean;
        constructor(container: HTMLElement) {
            this.triggers = [...container.querySelectorAll<HTMLElement>(`.${ACCORDION_SELECTOR}__trigger`)];
            this.allowMultiple = Object.hasOwn(container.dataset, 'allowMultiple');

            this.init();
        }

        init() {
            for (const trigger of this.triggers) {
                trigger.addEventListener('keydown', (event) => this.handleKeys(event, trigger));
                trigger.addEventListener('click', (event) => this.handleClick(event.currentTarget as HTMLElement));
            }
        }

        handleClick(trigger: HTMLElement) {
            if (!this.allowMultiple) {
                this.closeAllExcept(trigger);
            }
            this.toggleItem(trigger);
        }

        handleKeys(event: KeyboardEvent, currentTrigger: HTMLElement) {
            const { key } = event;
            const index = this.triggers.indexOf(currentTrigger);
            const length = this.triggers.length;

            // Stop scrolling the page when using arrow keys inside the accordion
            if (Object.values(KEYS).includes(key)) {
                event.preventDefault();
            }

            switch (key) {
                case KEYS.down: {
                    this.triggers[(index + 1) % length].focus();
                    break;
                }
                case KEYS.up: {
                    this.triggers[(index - 1 + length) % length].focus();
                    break;
                }
                case KEYS.home: {
                    this.triggers[0].focus();
                    break;
                }
                case KEYS.end: {
                    this.triggers[length - 1].focus();
                    break;
                }
            }
        }

        toggleItem(trigger: HTMLElement) {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            const panelId = trigger.getAttribute('aria-controls');
            const panel = document.querySelector<HTMLElement>(`#${panelId}`);

            if (!panel) return;

            trigger.setAttribute('aria-expanded', String(!isExpanded));
            panel.hidden = isExpanded;
        }

        closeAllExcept(activeTrigger: HTMLElement) {
            for (const trigger of this.triggers) {
                if (trigger !== activeTrigger) {
                    trigger.setAttribute('aria-expanded', 'false');

                    const panelId = trigger.getAttribute('aria-controls');
                    const panel = document.querySelector<HTMLElement>(`#${panelId}`);
                    if (panel) panel.hidden = true;
                }
            }
        }
    }

    for (const element of document.querySelectorAll(`.${ACCORDION_SELECTOR}`)) {
        if (element instanceof HTMLElement) new BuxAccordion(element);
    }
}
